import { observer } from 'mobx-react-lite';
import {
  Card,
  CardContent,
  Typography,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
} from '@mui/material';
import { useManagerTeam } from './ManagerTeamPage';

function formatDate(dateStr: string | null): string {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString();
}

export const ManagerTeamPayments = observer(() => {
  const { detail } = useManagerTeam();
  if (!detail) return null;

  const { payments } = detail;

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Payments ({payments.length})
        </Typography>
        {payments.length === 0 ? (
          <Alert severity="info">No payments recorded for this team.</Alert>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Plan</TableCell>
                  <TableCell align="right">Qty</TableCell>
                  <TableCell align="right">Amount</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Renews</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {payments.map((p) => (
                  <TableRow key={p.key}>
                    <TableCell>{formatDate(p.date_created)}</TableCell>
                    <TableCell>{p.product_id || '—'}</TableCell>
                    <TableCell align="right">{p.quantity}</TableCell>
                    <TableCell align="right">${(p.numeric_amount || 0).toFixed(2)}</TableCell>
                    <TableCell>
                      <Chip
                        label={p.success ? 'Success' : 'Failed'}
                        size="small"
                        color={p.success ? 'success' : 'error'}
                      />
                    </TableCell>
                    <TableCell>{formatDate(p.tasks_expire)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
});
